import HomeSwiper from './homeSwiper';

HomeSwiper.install = function( Vue ) {
    Vue.component( HomeSwiper.name, HomeSwiper );
};

export default HomeSwiper;



// WEBPACK FOOTER //
// ./src/components/homeSwiper/index.js